var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"download__csv",class:{ active: _vm.isLoadingFile },on:{"click":_vm.downloadFile}},[(_vm.isLoadingFile)?_c('loader'):_vm._e(),(!_vm.isLoadingFile)?_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v("Скачать XLSX")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }